<template>
  <div class="events-status-tile" :class="[statusTileClasses]">
    <apio-icon
      v-if="status === 'done' || status === 'success'"
      darkModeColour="white"
      lightModeColour="white"
      name="ui-circle-tick-filled"
    />
    <apio-icon
      v-if="status === 'warning'"
      darkModeColour="white"
      lightModeColour="white"
      name="ui-warning-circle"
    />
    <apio-icon
      v-if="status === 'error'"
      darkModeColour="white25"
      lightModeColour="white25"
      name="ui-error"
    />
    <div class="events-status-tile__status-text">
      {{ statusText }}
    </div>
    <v-progress-linear
      v-if="status === 'event'"
      background-color="white"
      height="8"
      indeterminate
      class="events-status-tile__progress--bar"
      color="purple"
    ></v-progress-linear>
  </div>
</template>

<script>
export default {
  name: "EventsStatusTile",
  props: {
    status: {
      required: true,
    },
  },
  computed: {
    statusTileClasses() {
      if (this.status === 'done' || this.status === 'success') {
        return "success white--text p2-extra-bold ";
      }
      if (this.status === 'event') {
        return "white apioshade2--text tiny events-status-tile__progress";
      }
      if (this.status === 'warning') {
        return "warning white--text p2-extra-bold ";
      }
      if (this.status === 'error') {
        return "error white--text p2-extra-bold ";
      }

      return "";
    },
    statusText() {
      if (this.status === 'done' || this.status === 'success') {
        return "Success";
      }
      if (this.status === 'event') {
        return "Processing...";
      }
      if (this.status === 'warning') {
        return "Warning";
      }
      if (this.status === 'error') {
        return "Error";
      }

      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.progress {
  bottom: 0;
  position: absolute;
  width: 72px;
}

.events-status-tile {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 72px;
  justify-content: center;
  max-width: 72px;
  min-width: 72px;
  position: relative;
  width: 100%;
  font-size: var(--font-paragraph-2-size);
  font-weight: var(--font-extra-bold);

  &__progress {
    font-size: var(--font-tiny-size);
    font-weight: normal;
    &--bar {
      bottom: 0;
      position: absolute;
      width: 100%;
    }
  }

  &__status-text {
    padding-top: 4px;
  }

  @media (max-width: 768px) {
    height: 50px;

    &__status-text {
      padding-top: 0;
      font-size: var(--font-small-size);
    }
  }
}
</style>